import { useCallback } from 'react';
import { useCardSectionRegistry } from '../../hooks/useCardSectionRegistry';
import { usePipeline } from 'crm-object-board-core/pipeline';
// this hook is used in cases such as approval
// where we need to make sure the pipeline has approval enabled.
export const useValidatePipeline = () => {
  const pipeline = usePipeline();
  const {
    data: registry
  } = useCardSectionRegistry();
  return useCallback(sectionKey => {
    var _registry$getAllSecti;
    const validatePipeline = (_registry$getAllSecti = registry.getAllSectionSettingConfigs()) === null || _registry$getAllSecti === void 0 || (_registry$getAllSecti = _registry$getAllSecti.get(sectionKey)) === null || _registry$getAllSecti === void 0 ? void 0 : _registry$getAllSecti.validatePipeline;

    // If a section needs to validate for the pipeline, it can only be valid if the card is in the context of a pipeline
    return validatePipeline ? Boolean(pipeline && validatePipeline(pipeline)) : true;
  }, [registry, pipeline]);
};